import { Context, contextStore } from '@wix/wix-chatbot-common/browser';

import { getState } from '../store';
import { isMobile } from './index';

export const getContext = (): Promise<Context> => {
  const {
    context: { user },
  } = getState();

  if (user) {
    contextStore.setUserData(user.userId, user.userExperience, user.careProfile, user.accountId);
  }
  contextStore.setPlatform(isMobile());
  contextStore.setIsWidget(true);

  return Promise.resolve(contextStore.getContextForApi());
};
